import { API, axios } from '@Root/API'

export const getStatic = () => {
	return Promise.all([axios.get('cleric-types'), API.admin.institution.getRelated()])
}
